// extracted by mini-css-extract-plugin
module.exports = {"card-description-hide":"gridstyle_card-description-hide__1Lgjt"};